import React, { useEffect, useState } from "react";
import { getRestaurantProfile, updateRestaurantProfile } from "./adminApi";

export default function RestaurantProfile({ restaurantId, onSaved }) {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "", email: "", address: "" });
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    let alive = true;
    setProfile(null); setError(""); setSuccess(""); setLogo(null);
    getRestaurantProfile(restaurantId).then(data => {
      if (!alive) return;
      setProfile(data);
      setForm({ name: data.name || "", phone: data.phone || "", email: data.email || "", address: data.address || "" });
    }).catch(e => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, [restaurantId]);

  useEffect(() => {
    if (!logo) { setPreview(""); return; }
    const url = URL.createObjectURL(logo);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [logo]);

  async function save(event) {
    event.preventDefault(); setBusy(true); setError(""); setSuccess("");
    try {
      const result = await updateRestaurantProfile(restaurantId, form, logo);
      setProfile(result); setLogo(null); setSuccess("Restaurant profile saved successfully.");
      if (onSaved) onSaved(result);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }

  if (!profile && !error) return <section className="ra-panel">Loading restaurant profile…</section>;
  return <section className="ra-panel ra-profile">
    <h2>Restaurant Profile</h2>
    <p>Manage your restaurant identity and contact information.</p>
    {error && <p className="ra-alert ra-alert-error" role="alert">{error}</p>}
    {success && <p className="ra-alert ra-alert-success" role="status">{success}</p>}
    {profile && <form onSubmit={save} className="ra-profile-form">
      <label>Restaurant name <input required maxLength={150} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}/></label>
      <label>Phone <input maxLength={20} value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}/></label>
      <label>Email <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}/></label>
      <label>Address <textarea rows={4} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })}/></label>
      <div className="ra-logo-row">
        {(preview || profile.logo_url) && <img className="ra-logo-preview" src={preview || profile.logo_url} alt="Restaurant logo" />}
        <label>Restaurant logo (PNG, JPEG or WebP, max 2 MB)
          <input type="file" accept="image/png,image/jpeg,image/webp" onChange={e => {
            const file = e.target.files?.[0] || null;
            if (file && file.size > 2 * 1024 * 1024) { setError("Logo must be 2 MB or smaller."); e.target.value = ""; return; }
            setError(""); setLogo(file);
          }}/>
        </label>
      </div>
      <div className="ra-profile-meta"><span>URL slug: <strong>{profile.slug}</strong></span><span>Customer theme: <strong>{profile.theme}</strong></span></div>
      <button className="ra-save" type="submit" disabled={busy}>{busy ? "Saving…" : "Save restaurant profile"}</button>
    </form>}
  </section>;
}